import type { FC } from 'react';

export const RenameIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.45825 2.29105L7.63675 3.46956M5.41667 8.7491H8.75M1.25 8.74927L1.26977 8.6109C1.33973 8.12115 1.37472 7.87627 1.45429 7.64765C1.5249 7.44481 1.62135 7.2519 1.74127 7.07369C1.87642 6.87285 2.05133 6.69794 2.40114 6.34815L7.25446 1.49481C7.57992 1.16938 8.10754 1.16937 8.433 1.49481C8.75842 1.82025 8.75842 2.34788 8.433 2.67332L3.4906 7.61569C3.17325 7.93306 3.01457 8.09173 2.83383 8.21794C2.67341 8.32994 2.50039 8.42273 2.31833 8.4944C2.11321 8.5751 1.89323 8.61948 1.4533 8.70827L1.25 8.74927Z"
      stroke={props.color || '#E6E6E9'}
      stroke-width="0.833333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
